<!-- =========================================================================================
    File Name: VerifyinvitedUserPhone.vue
    Description: Verify Invited User Phone Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img v-if="setVerifyEmailPageImage" :src="img_cdn + setVerifyEmailPageImage" alt="login" class="mx-auto">
            </div>


            <div v-if="verifyPin" class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Enter Pin Code!</h4>
                  <p class="mb-4">An SMS has been sent with pin code kindly check your SMS to activate your account.</p>
                  <!--                  <p>Your are re.</p>-->
                </div>
                <div v-on:keyup.enter="submitData">
                  <vs-input
                    v-validate="'numeric|required|min:6|max:6|'"
                    name="pin"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Pin Code"
                    v-model="pinCode"
                    autofocus
                    class="w-full"/>

                  <span class="text-danger text-sm" v-show="errors.has('pin')">{{ errors.first('pin') }}</span>

                  <br>
                  <br>
                  <p v-if="invalidToken">Your phone not confirmed try again please!</p>
                  <router-link to="/login">
                    <vs-button type="border">Cancel</vs-button>
                  </router-link>
                  <vs-button class="float-right" :disabled="!validateForm" @click.native="submitData">Activate</vs-button>
                  <br>
                </div>
              </div>
            </div>

            <!--            EMAIL SUCCESSFULLY APPROVED-->
              <div v-if="varified" class="p-6"  v-on:keyup.enter="setPassword">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Set Username & Password!</h4>
                </div>
                <p>Your Phone has been approved set your password to login.</p>

                <vs-input
                  ref="Username"
                  type="Username"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  @input="checkUserName"
                  name="text"
                  label-placeholder="Username"
                  placeholder="Username"
                  v-model="dataUsername"
                  class="w-full mt-6" />
                <span class="text-danger text-sm">{{ errors.first('Username') }}</span>
                <span class="text-danger text-sm" v-if="UserDuplicate>0">Username has already been taken !</span>

                <vs-input v-if="enabled" placeholder="Email" label-placeholder="Email" @input="acceptEmail" v-model="dataEmail" class="w-full mt-6" name="email" v-validate="'email|required'" />
                <vs-input v-else disabled  placeholder="Email" label-placeholder="Email" @input="acceptEmail" v-model="dataEmail" class="w-full mt-6" name="email" v-validate="'email|required'" />
                <span v-if="enabled" class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                <span  class="text-danger text-sm" v-if="Duplicate>0">Email has already been taken!</span>
                <br>
                <vx-input-group>
                  <template slot="append">
                    <div class="append-text cursor-pointer" style="color:#B0AFB7;background-color:white;border:1px solid rgba(0, 0, 0, 0.2); border-left:none">
                      <span @click="showPassword = !showPassword">
                              <feather-icon v-if="showPassword" icon="EyeOffIcon"  class="flex-inline mt-2" svgClasses="h-5 w-5" />
                              <feather-icon v-else icon="EyeIcon"  class="flex-inline mt-2" svgClasses="h-5 w-5" />
                        </span>
                    </div>
                  </template>

                  <vs-input 
                  ref="password"
                  v-model="dataPassword" 
                   data-vv-validate-on="blur"
                   v-validate="'required|min:6|max:20'"
                    v-bind:type="[showPassword ? 'text' : 'password']" 
                    name="password"
                    placeholder="Password"
                    class="w-full no-right-border"
                  />
                </vx-input-group>
                <span class="text-danger text-sm">{{ errors.first('password') }}</span>


                <vs-input
                  type="password"
                  v-validate="'min:6|max:20|confirmed:password'"
                  data-vv-validate-on="blur"
                  data-vv-as="password"
                  name="confirm_password"
                  label-placeholder="Confirm Password *"
                  placeholder="Confirm Password"
                  v-model="dataConfPassword"
                  class="w-full mt-6" />
                <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

                <div class="flex flex-wrap items-center p-6" slot="footer">
                  <vs-button class="mr-6" @click.native="setPassword" :disabled="!isFormValid">Submit</vs-button>
<!--                  <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>-->
                </div>

              </div>


<!--            EMAIL ALREADY APPROVED-->
            <div v-if="alreadApproved" class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Email Already Approved!</h4>
                </div>
                <div>
                  <p>Your Email has Already Approved click to login</p>
                  <br>
                  <router-link to="/login">
                    <vs-button class="float-right" type="border">Login</vs-button>
                  </router-link>
<!--                  <vs-button class="float-right" @click="submitData">Login</vs-button>-->
                  <br>
                </div>
              </div>
            </div>


          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {
  GET_IMAGE_SETTING,
  SINGLE_USER_BY_USERNAME,
  UPDATE_SMS_INVITED_USER_PASSWORD,
  VERIFY_INVITED_USER_PHONE,
  SINGLE_USER_BY_EMAIL
} from '@/graphql'


export default {
  data () {
    return {
      varified: false,
      invalidToken: false,
      pinCode: '',
      UserDuplicate:0,
      verifyPin: true,
      userPinTime: '',
      alreadApproved: false,
      dataUsername:'',
      dataPassword:'',
      dataConfPassword:'',
      dataEmail:null,
      enabled:false,
      img_cdn:process.env.VUE_APP_IMAGES_CDN_LINK,
      setVerifyEmailPageImage:'',
      Duplicate:0,
      showPassword:false,


    }
  },
  computed: {
    isFormValid () {
      return !this.errors.any() && this.dataUsername && this.dataPassword && this.dataConfPassword && this.UserDuplicate === 0  && this.Duplicate === 0 && (this.dataPassword === this.dataConfPassword)
    },
    validateForm () {
      return !this.errors.any() && this.pinCode !== ''
    }
  },
  methods: {
    acceptEmail () {
      this.$apollo
        .mutate({
          mutation: SINGLE_USER_BY_EMAIL,
          variables: {
            email: this.dataEmail
          }
        })
        .then(response => {
          this.Duplicate = response.data.userByEmail.length
        })
    },
    checkUserName () {
      const letterNumber = /[^a-zA-Z0-9]/g
      if (this.dataUsername.match(letterNumber)) {
        console.log(letterNumber)
      } else if (this.dataUsername) {
        this.$apollo
          .mutate({
            mutation: SINGLE_USER_BY_USERNAME,
            variables: {
              username: this.dataUsername
            }
          })
          .then(response => {
            this.UserDuplicate = response.data.userByUserName.length
          })
      }
    },
    setPassword () {
      if (this.dataPassword.length !== 0) {
        if (this.userPinTime !== null) {
          this.$apollo
            .mutate({
              mutation: UPDATE_SMS_INVITED_USER_PASSWORD,
              variables: {
                token: parseInt(localStorage.getItem('userPinCode')),
                pin_url: this.userPinTime,
                password: this.dataPassword,
                username: this.dataUsername,
                email:this.dataEmail
              }
            }).then(response => {
              if (response.data.updateSmsInvitedUserPassword.status === 'SUCCESS') {

                this.$vs.notify({
                  title: 'Password',
                  text: 'Password Updated Successfully',
                  color: 'success',
                  position: 'top-right'
                })
                this.$router.replace('/login')

              } else if (response.data.updateSmsInvitedUserPassword.status === 'NOT_AUTHORIZED') {

                this.$vs.notify({
                  title: 'Not Authorized',
                  text: 'User Not Authorized',
                  color: 'danger',
                  position: 'top-right'
                })
              }
            })
        } else {
          this.$vs.notify({
            title: 'Not Found',
            text: 'User not found',
            color: 'danger',
            position: 'top-right'
          })

        }
      }

      this.$emit('closeSidebar')
      this.$validator.reset()
      // this.initValues()

    },

    submitData () {
      this.$apollo
        .mutate({
          mutation: VERIFY_INVITED_USER_PHONE,
          variables: {
            token: this.pinCode,
            pin_url: this.userPinTime
          }
        })
        .then(response => {
          if (this.validEmail(response.data.verifyInvitedUserPhone.user.email)) {
            this.dataEmail = response.data.verifyInvitedUserPhone.user.email
            this.enabled = false
          } else {
            this.dataEmail = null
            this.enabled = true
          }

          if (response.data.verifyInvitedUserPhone.status == 'SUCCESS') {
            localStorage.removeItem('userPinCode')
            localStorage.setItem('userPinCode', response.data.verifyInvitedUserPhone.access_token)
            this.varified = true
            this.invalidToken = false
            this.verifyPin = false
            this.alreadApproved = false
            // this.$router.replace('/login')
            this.SuccessStatus()
          } else if (response.data.verifyInvitedUserPhone.status === 'TOKEN_EXPIRE') {
            this.varified = false
            this.invalidToken = false
            this.alreadApproved = false
            this.verifyPin = true
            this.StatusExpire()
          } else if (response.data.verifyInvitedUserPhone.status === 'ALREADY_APPROVED') {
            localStorage.removeItem('userPinCode')
            localStorage.setItem('userPinCode', response.data.verifyInvitedUserPhone.access_token)
            this.varified = true
            this.invalidToken = false
            this.verifyPin = false
            this.alreadApproved = false
            // this.$router.replace('/login')
            this.emailAlreadyApprovedNotification()
          } else if (response.data.verifyInvitedUserPhone === null) {
            this.varified = false
            this.invalidToken = false
            this.verifyPin = false
            this.alreadApproved = false
            // this.$router.replace('/login')
            this.NotFoundNotification()
          }
        }).catch(error => {
          this.varified = false
          this.invalidToken = true
          this.verifyPin = true
          this.alreadApproved = false
          this.NotFoundNotification()
          console.log(error)
        })

    },
    validEmail (value) {
      if (value.slice(0, 8) === 'temp-kv-'  &&  /^\d+$/.test(value.slice(9, 18))  &&  value.slice(value.length - 14) === 'kidsvision.com') {
        return false
      } else {
        return true
      }
    },
    SuccessStatus () {
      this.$vs.notify({
        title: 'Phone',
        text: 'Verified Successfully ',
        color: 'success',
        position: 'top-right'
      })

    },
    StatusInvalid () {

      this.$vs.notify({
        title: 'Incorrect Data',
        text: 'Check and Enter again',
        color: 'danger',
        position: 'top-right'
      })
    },
    StatusExpire () {

      this.$vs.notify({
        title: 'Token Expired',
        text: 'Your token has been expired',
        color: 'danger',
        position: 'top-right'
      })
    },
    emailAlreadyApprovedNotification () {
      this.$vs.notify({
        title: 'Approved Successfully',
        text: '',
        color: 'success',
        position: 'top-right'
      })
    },
    NotFoundNotification () {
      this.$vs.notify({
        title: 'Not Found',
        text: 'User Not Found',
        color: 'danger',
        position: 'top-right'
      })
    }
    

  },
  beforeCreate () {
    this.$apollo
      .query({
        query: GET_IMAGE_SETTING
      })
      .then(response => {
        if (response.data.getImagesSetting.verify_email_page_image != null) {
          this.setVerifyEmailPageImage = response.data.getImagesSetting.verify_email_page_image
        }
      })
      .catch(error => {
        console.log(error)
      })
  },
  created () {
    this.userPinTime =  this.$route.params.pin_time

  }

}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1
    }

    .bg-twitter {
      background-color: #00aaff
    }

    .bg-google {
      background-color: #4285F4
    }

    .bg-github {
      background-color: #333
    }
  }
}
</style>
